import { ArrayHelper } from 'apps/idl/src/helpers/arrayHelper';
import { DateHelper } from 'apps/idl/src/helpers/dateHelper';
import { UserHelper } from 'apps/idl/src/helpers/user.helper';
import { ResolveModel } from 'apps/idl/src/modules/utils/models/decorators/resolve-model.decorator';
import { Exclude, Expose } from 'class-transformer';
import { EConstraintType } from './EConstraintType';
import { ActeOccurrenceComparator } from './acte-occurrence-comparator';
import { IActeOccurrence } from './iacte-occurrence';
import { IConstraint } from './iconstraint';
import { IConstraintLabelParams } from './iconstraint-label-params';

export abstract class Constraint implements IConstraint {

	//#region PROPERTIES

	/** @implements */
	@Exclude()
	@ResolveModel(ActeOccurrenceComparator)
	private maOccurrenceComparators: ActeOccurrenceComparator[];
	@Expose()
	public get occurrenceComparators(): ActeOccurrenceComparator[] {
		if (!this.maOccurrenceComparators)
			this.maOccurrenceComparators = [];

		return this.maOccurrenceComparators;
	}
	public set occurrenceComparators(paOccurrenceComparators: ActeOccurrenceComparator[]) {
		if (paOccurrenceComparators !== this.maOccurrenceComparators)
			this.maOccurrenceComparators = paOccurrenceComparators;
	}

/** @implements */
@Exclude()
@ResolveModel(ActeOccurrenceComparator)
private maExcluOccurrenceComparators: ActeOccurrenceComparator[];
@Expose()
public get ExcludeOccurrenceComparators(): ActeOccurrenceComparator[] {
	if (!this.maExcluOccurrenceComparators)
		this.maExcluOccurrenceComparators = [];

	return this.maExcluOccurrenceComparators;
}
public set ExcludeOccurrenceComparators(paOccurrenceComparators: ActeOccurrenceComparator[]) {
	if (paOccurrenceComparators !== this.maExcluOccurrenceComparators)
		this.maExcluOccurrenceComparators = paOccurrenceComparators;
}


	/** @implements */
	public abstract readonly type: EConstraintType;

	/** @implements */
	public decription?: string;
	@Exclude()
	private msCreateUserContactId: string = UserHelper.getUserContactId();
	/** @implements */
	@Expose()
	public get createUserContactId(): string { return this.msCreateUserContactId; }
	public set createUserContactId(psCreateUserContactId: string) {
		if (psCreateUserContactId !== this.msCreateUserContactId)
			this.msCreateUserContactId = psCreateUserContactId;
	}

	@Exclude()
	private mdCreateDate: Date;
	/** @implements */
	@Expose()
	public get createDate(): Date { return this.mdCreateDate; }
	public set createDate(pdCreateDate: Date) {
		if (DateHelper.isDate(pdCreateDate) && pdCreateDate !== this.mdCreateDate)
			this.mdCreateDate = new Date(pdCreateDate);
	}

	//#endregion

	//#region METHODS

	constructor() {
		this.mdCreateDate = new Date;
	}

	public getLabel(poParams: IConstraintLabelParams): string {
		return `Séance(s) ${this.getOccurrencesLabel(poParams)}: ${this.buildlabel(poParams)}`;
	};

	/** Indique si on peut appliquer la contrainte à l'occurrence.
	 * @param poActeOccurrence
	 */
	public match(poActeOccurrence: IActeOccurrence): boolean {
		if (!ArrayHelper.hasElements(this.occurrenceComparators))
			return true;
		return !this.ExcludeOccurrenceComparators.some((poOccurenceComparator: ActeOccurrenceComparator) => poOccurenceComparator.match(poActeOccurrence)) && this.occurrenceComparators.every((poOccurenceComparator: ActeOccurrenceComparator) => poOccurenceComparator.match(poActeOccurrence));
	}

	/** Action à effectuer sur l'occurrence.
	 * @param poActeOccurrence
	 */
	public abstract action(poActeOccurrence: IActeOccurrence): void;

	/** Construit la description de la contrainte. */
	public abstract buildlabel(poParams?: IConstraintLabelParams): string;

	public getIntervenantsIds(): string[] {
		return [];
	}

	/** Récupère la description des occurrences. */
	private getOccurrencesLabel(poParams: IConstraintLabelParams): string {
		return `${this.occurrenceComparators.map((poItem: ActeOccurrenceComparator) => poItem.getLabel(poParams)).join(" - ")} `;
	}

	//#endregion

}
